/*
ContactMessage
*/

import React, { Component } from 'react';
import autoBind from 'react-autobind';
import classnames from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { reset, reduxForm, Field } from 'redux-form';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, bindActionCreators } from 'redux';
import { addMessage } from 'store/features/common/flash/actions';
import { messageTypes } from 'store/features/common/flash/builder';

import Alert from 'ui/common/alert';

import TextField from 'ui/common/form/fields/text-field';
import validator from 'ui/common/form/validator';
import SubmitButton from 'ui/common/form/submit-button';
import fields, { fieldNames } from './model';
import styles from './index.module.scss';
import messages from './messages';
import * as actionTypes from 'store/graphql/ContactMessage/action-types';
import { selectIsUpdating, selectError } from 'store/graphql/ContactMessage/selectors';
import ContactMessageReducer from 'store/graphql/ContactMessage/reducer';
import injectReducer from 'utils/injectReducer';
const validate = validator(fields);
const formName = 'contact-message';

class ContactMessage extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  async onSubmit(values) {
    const {
      client,
      addMessageStart,
      addMessageSuccess,
      addMessageError,
      addMessage,
      intl: { formatMessage },
    } = this.props;
    // console.log(values)
    const { name, email, message } = values;
    addMessageStart();

    try {
      const resultFromGraphQl = await client.mutate({
        mutation: gql`
          mutation recordContactForm($form: ContactRequestInput!) {
            recordContactForm(form: $form)
          }
        `,
        variables: {
          form: {
            firstName: name,
            email,
            message,
          },
        },
      });

      if (resultFromGraphQl.error) {
        addMessageError(resultFromGraphQl.error);
      } else {
        addMessageSuccess();
        addMessage({
          kind: messageTypes.success,
          content: formatMessage(messages.success),
        });
      }
    } catch (error) {
      addMessageError(error.message);
    }
  }

  render() {
    const { handleSubmit, errorMessage, intl: { formatMessage } } = this.props;

    return (
      <div className={classnames('text-left col-8 col-sm-8', styles.leftItems)}>
        <p>
          <FormattedMessage
            id="pages.contact.intro"
            defaultMessage="We are here to answer any questions you may have about our program. Reach out to us and we will respond as soon as possible."
          />
        </p>
        <form onSubmit={handleSubmit(this.onSubmit)}>
          {errorMessage && (
            <Alert color="danger" inverse>
              {errorMessage}
            </Alert>
          )}
          <div>
            <Field
              name={fieldNames.name}
              component={TextField}
              label={formatMessage(messages[fieldNames.name])}
            />
          </div>
          <div>
            <Field
              name={fieldNames.email}
              component={TextField}
              label={formatMessage(messages[fieldNames.email])}
            />
          </div>
          <div>
            <Field
              multiLine
              name={fieldNames.message}
              component={TextField}
              label={formatMessage(messages[fieldNames.message])}
            />
          </div>
          <div className="mt-3">
            <SubmitButton fullWidth formName={formName}>
              {formatMessage(messages.submitButton)}
            </SubmitButton>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  const name = '';
  const email = '';
  const message = '';

  return {
    initialValues: {
      [fieldNames.name]: name,
      [fieldNames.email]: email,
      [fieldNames.message]: message,
    },
    updating: selectIsUpdating(state),
    errorMessage: selectError(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addMessageStart: () => dispatch({ type: actionTypes.ADD_MESSAGE.START }),
    addMessageSuccess: () => dispatch({ type: actionTypes.ADD_MESSAGE.SUCCESS }),
    addMessageError: error =>
      dispatch({ type: actionTypes.ADD_MESSAGE.FAILURE, payload: { error } }),
    addMessage: bindActionCreators(addMessage, dispatch),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({
  key: 'ContactMessage',
  reducer: ContactMessageReducer,
});

const afterSubmit = (result, dispatch) => dispatch(reset(formName));

export default compose(withReducer, withConnect)(
  reduxForm({
    form: formName,
    validate,
    onSubmitSuccess: afterSubmit,
  })(injectIntl(withApollo(ContactMessage)))
);



// WEBPACK FOOTER //
// ./src/ui/graphql/ContactMessage/index.js